import { useState } from "react";
import { useLocation } from "react-router-dom";
import { brand } from "@/mocks/siteData";

const WA_MESSAGE = `Hi Rythugaru! I'd like to know more about your farm experiences and plan a visit. You can reply here on WhatsApp, or reach me on the enquiry line ${brand.phone}.`;

export default function QuickContactBanner() {
  const { pathname } = useLocation();
  const [open, setOpen] = useState(true);
  const whatsappHref = `https://wa.me/${brand.whatsapp}?text=${encodeURIComponent(WA_MESSAGE)}`;

  // This is a public visitor contact widget — it stays out of the admin portal,
  // which already has its own Help & Support entry points.
  if (pathname.startsWith("/admin")) return null;

  if (!open) {
    return (
      <button
        type="button"
        onClick={() => setOpen(true)}
        aria-label="Open quick contact"
        className="fixed z-40 bottom-5 right-5 w-14 h-14 flex items-center justify-center rounded-full bg-accent-500 text-background-50 hover:bg-accent-600 transition-colors cursor-pointer"
      >
        <i className="ri-whatsapp-line text-2xl"></i>
      </button>
    );
  }

  return (
    <div className="fixed z-40 bottom-0 left-0 right-0 md:bottom-6 md:left-auto md:right-6 md:w-[22rem]">
      <div className="bg-primary-900 text-background-100 border border-primary-800 rounded-t-lg md:rounded-lg px-4 py-4 md:px-5 md:py-5">
        <div className="flex items-start justify-between gap-4">
          <div className="flex items-center gap-3">
            <span className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-500 text-background-50 shrink-0">
              <i className="ri-chat-3-line text-xl"></i>
            </span>
            <div>
              <p className="font-heading text-base md:text-lg text-background-50 font-semibold leading-tight">
                Have a question?
              </p>
              <p className="text-xs text-background-300 mt-0.5">
                Message us on WhatsApp — we reply fast
              </p>
            </div>
          </div>
          <button
            type="button"
            onClick={() => setOpen(false)}
            aria-label="Dismiss quick contact"
            className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-primary-800 text-background-300 hover:text-background-50 transition-colors cursor-pointer shrink-0"
          >
            <i className="ri-close-line text-lg"></i>
          </button>
        </div>

        <div className="flex flex-col sm:flex-row md:flex-col gap-2 mt-4">
          <a
            href={whatsappHref}
            target="_blank"
            rel="noopener noreferrer"
            className="flex-1 inline-flex items-center justify-center gap-2 bg-accent-500 text-background-50 text-sm font-semibold px-4 py-3 rounded-md hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-whatsapp-line text-lg"></i>
            Chat on WhatsApp
          </a>
          <div className="flex gap-2">
            <a
              href={`tel:${brand.phone}`}
              className="flex-1 inline-flex items-center justify-center gap-2 bg-primary-800 text-background-50 text-sm font-semibold px-4 py-3 rounded-md hover:bg-primary-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-line text-lg"></i>
              Call
            </a>
            <a
              href={`mailto:${brand.email}`}
              className="flex-1 inline-flex items-center justify-center gap-2 bg-primary-800 text-background-50 text-sm font-semibold px-4 py-3 rounded-md hover:bg-primary-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-mail-line text-lg"></i>
              Email
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}